var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2959 6.03507C12.7213 5.75145 13.2787 5.75145 13.7041 6.03507L23.1075 12.3041C23.8461 12.7965 23.8461 13.8701 23.1075 14.3625L13.7041 20.6316C13.2787 20.9152 12.7213 20.9152 12.2959 20.6316L2.89248 14.3625C2.15386 13.8701 2.15386 12.7965 2.89248 12.3041L12.2959 6.03507Z",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0909 16.25L20.0909 20.5007C20.0909 21.1293 19.7895 21.7209 19.2784 22.0958L14.2003 25.8197C13.4877 26.3424 12.5123 26.3424 11.7997 25.8197L6.72164 22.0958C6.21045 21.7209 5.90911 21.1293 5.90911 20.5007L5.90911 16.25",
    stroke: "#68768B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2969 22.0828C22.2969 22.497 22.6327 22.8328 23.0469 22.8328C23.4611 22.8328 23.7969 22.497 23.7969 22.0828H22.2969ZM22.2969 13.916V22.0828H23.7969V13.916H22.2969Z",
    fill: "#68768B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.511bdf59ad56ee1191e3fe49c3893e6f.svg";
export { ForwardRef as ReactComponent };